import {
  CookieName,
  getCookie,
  getCookieKeyByInfo,
  GodziDropMessageType,
  LayoutType,
  MessageSender,
} from '@funkygame/promotion-lib'
import {
  Ga4EventType,
  ga4Info,
  getApiEndpointFullyQualifiedDomain,
  getShortLang,
  usePlayerStore,
  useVoucherStore,
} from '@slot-nx/core'
import { useGodziDropStore } from '../store/godziDropStore'
import { gameConfig } from '../../../config'
import { MachineActionType, sweetBombMachine } from '../../../../machine/sweetbombMachine'

class GodziDashboardService {
  private godziDropWrapper: HTMLElement
  private godziDropIframe: HTMLIFrameElement

  public init() {
    const { eventInfo } = useGodziDropStore.getState()
    this.checkHasVoucher()
    if (eventInfo.isIconOpen) {
      window.addEventListener('resize', this.updateIFrameSize.bind(this))
      window.addEventListener('message', (event) => {
        if (event.data.name === GodziDropMessageType.Close) {
          this.closeGodziDropDashBoard()
          useGodziDropStore.setState({ isShowDashboard: false })
        }
      })

      this.addGodziDropIframe()
    }
  }

  private isGodziDropDomCreated() {
    return document.getElementById('GodziDropWrapper')
  }

  public updateIFrameSize() {
    if (this.isGodziDropDomCreated()) {
      document.body.style.height = `${window.innerHeight}px`
      document.body.style.overflow = 'hidden'

      this.updateWindowSize()
    }
  }

  private updateWindowSize() {
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight
    this.godziDropIframe.style.width = `${windowWidth}px`
    this.godziDropIframe.style.height = `${windowHeight}px`
  }

  private addGodziDropIframe() {
    if (!this.isGodziDropDomCreated()) {
      this.godziDropWrapper = document.createElement('div')
      this.godziDropWrapper.id = 'GodziDropWrapper'
      this.closeGodziDropDashBoard()
      document.body.appendChild(this.godziDropWrapper)

      this.godziDropIframe = document.createElement('iframe')
      const { language, authToken } = usePlayerStore.getState()

      const lang = getShortLang(gameConfig.languageList, language)

      this.godziDropIframe.src = `${this.getUrl()}${lang}/?token=${authToken}&layout=${LayoutType.Vertical}`
      this.godziDropIframe.className = 'godziDrop'
      this.godziDropWrapper.appendChild(this.godziDropIframe)
    }
  }

  private getUrl() {
    return `https://${getApiEndpointFullyQualifiedDomain()}/godzidrop/frontend/`
  }

  public openGodziDropDashBoard() {
    this.godziDropWrapper.style.display = 'block'
    this.godziDropIframe.contentWindow?.postMessage(
      { name: GodziDropMessageType.Open, sender: MessageSender.godziDrop },
      '*',
    )
    ga4Info.addEvent(Ga4EventType.close_promotion_panel)
  }

  private closeGodziDropDashBoard() {
    this.godziDropWrapper.style.display = 'none'
  }

  // TODO: 未被觸發
  public autoShowDashboard() {
    const goziDropStore = useGodziDropStore.getState()
    if (!goziDropStore.eventInfo.isIconOpen) return
    const godziDropStatusCookieKey = getCookieKeyByInfo({
      cookieName: CookieName.GodziDropStatus,
      promotionId: goziDropStore.eventInfo.promotionId,
      gameCode: gameConfig.gameCode,
    })

    const shouldShow
      = getCookie(godziDropStatusCookieKey) !== 'Hidden'

    if (shouldShow) useGodziDropStore.setState({ isShowDashboard: true })
  }

  public checkHasVoucher() {
    const slotVoucher = useVoucherStore.getState().tempSlotVoucher

    if (slotVoucher !== null && slotVoucher !== undefined) {
      sweetBombMachine.send({ type: MachineActionType.enterVoucherMachine })
    }
    else {
      sweetBombMachine.send({ type: MachineActionType.godziPopupClosed })
    }
  }
}

export const godziDashboardService = new GodziDashboardService()
